import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

// When the user clicks on ProductStockStoreLink, from the product page
export function createProductStocksDrawerOpenIntent(productSku: string): WebViewIntent {
  return createIntent('PRODUCT_STOCKS_DRAWER_OPEN', {
    productSku,
  })
}
